

const SET_IS_FILTER_DATA_LOADING = (state, isLoading) => {
  state.isFilterLoading = isLoading;
};

const FILTER_DATA_UPDATED = (state, data) => {
  state.filterData = data;
};

const FILTER_DATA = (state, data) => {
  state.filterData = data;
};



const SET_IS_AGREEMENT_UTILIZATION_LIST_LOADING = (state, isLoading) => {
  state.isAgreementUtilizationListLoading = isLoading;
};

const AGREEMENT_UTILIZATION_LIST_UPDATED = (state, data) => {
  state.agreementUtilizationList = data;
};

const SET_IS_AGREEMENT_UTILIZATION_DETAIL_LOADING = (state, isLoading) => {
  state.isAgreementUtilizationDetailLoading = isLoading;
};

const AGREEMENT_UTILIZATION_DETAIL_UPDATED = (state, data) => {
  state.agreementUtilizationDetail = data;
};

const SET_IS_INSTANCE_FAMILY_UTILIZATION_LIST_LOADING = (state, isLoading) => {
  state.isInstanceFamilyUtilizationListLoading = isLoading;
};

const INSTANCE_FAMILY_UTILIZATION_LIST_UPDATED = (state, data) => {
  state.instanceFamilyUtilizationList = data;
};

const SET_IS_SERVICE_UTILIZATION_LIST_LOADING = (state, isLoading) => {
  state.isServiceUtilizationListLoading = isLoading;
};

const SERVICE_UTILIZATION_LIST_UPDATED = (state, data) => {
  state.serviceUtilizationList = data;
};

const SET_IS_TOTAL_SUMMARY_LOADING = (state, isLoading) => {
  state.isTotalSummaryLoading = isLoading;
};

const TOTAL_SUMMARY = (state, data) => {
  state.totalSummary = data;
};

const TOTAL_SUMMARY_UPDATED = (state, data) => {
  state.totalSummary = data;
};

const SET_IS_TRANSITION_LOADING = (state, isLoading) => {
  state.isTransitionLoading = isLoading;
};

const TRANSITION = (state, data) => {
  state.transition = data;
};

const TRANSITION_UPDATED = (state, data) => {
  state.transition = data;
};



const SET_DISPLAYED_WARNING_BANNER = (state, pageName) => {
  if (pageName === TAB_INDEX.CLOUD_BILL_DETAIL) {
    state.chargeTableState.cloudBillDetails.displayedWarning = false;
  } else if (pageName === TAB_INDEX.CLOUD_INVOICE_LIST) {
    state.chargeTableState.cloudInvoiceList.displayedWarning = false;
  }
  setValueToStorageByKey(LOCAL_STORAGE_KEY.BILLING_TABLE_STATE, state.chargeTableState);
};

const SET_SELECTED_VENDOR = (state, vendor) => {
  state.selectedVendor = vendor;
};

export default {
  SET_IS_FILTER_DATA_LOADING: SET_IS_FILTER_DATA_LOADING,
  FILTER_DATA_UPDATED: FILTER_DATA_UPDATED,
  FILTER_DATA,

  SET_IS_AGREEMENT_UTILIZATION_LIST_LOADING: SET_IS_AGREEMENT_UTILIZATION_LIST_LOADING,
  AGREEMENT_UTILIZATION_LIST_UPDATED: AGREEMENT_UTILIZATION_LIST_UPDATED,

  SET_IS_AGREEMENT_UTILIZATION_DETAIL_LOADING: SET_IS_AGREEMENT_UTILIZATION_DETAIL_LOADING,
  AGREEMENT_UTILIZATION_DETAIL_UPDATED: AGREEMENT_UTILIZATION_DETAIL_UPDATED,

  SET_IS_INSTANCE_FAMILY_UTILIZATION_LIST_LOADING: SET_IS_INSTANCE_FAMILY_UTILIZATION_LIST_LOADING,
  INSTANCE_FAMILY_UTILIZATION_LIST_UPDATED: INSTANCE_FAMILY_UTILIZATION_LIST_UPDATED,

  SET_IS_SERVICE_UTILIZATION_LIST_LOADING: SET_IS_SERVICE_UTILIZATION_LIST_LOADING,
  SERVICE_UTILIZATION_LIST_UPDATED: SERVICE_UTILIZATION_LIST_UPDATED,

  SET_IS_TOTAL_SUMMARY_LOADING,
  TOTAL_SUMMARY,
  TOTAL_SUMMARY_UPDATED,

  SET_IS_TRANSITION_LOADING,
  TRANSITION,
  TRANSITION_UPDATED,

  SET_DISPLAYED_WARNING_BANNER,
  SET_SELECTED_VENDOR
};



// WEBPACK FOOTER //
// ./src/store/modules/azure-reserved/azure-utilization/mutations.js